import { MenuItem } from "./types";

export const transfer_station_sub_client_logs_and_history = [{
    permission: 'USER_ACTION_HISTORY',
    to: '/subclient/log-history/user?sortBy=actionTime&orderBy=DESC&page=1&pageSize=10',
    title: 'User Action History'
}]


export const transfer_station_sub_client_system_settings = [{
    permission: 'MANAGE_ACCOUNT_GROUPS',
    to: '/subclient/system-settings/account-groups?sortBy=accountGroupName&orderBy=ASC&page=1&pageSize=10',
    title: 'Account Groups'
},
{
    permission: "MANAGE_LETTERS",
    to: "/subclient/system-settings/manage-letters",
    title: "Manage Letter(s)",
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/tax-fee-types',
    title: 'Tax/Fee Types'
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/material-types',
    title: 'Material Types'
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/commodity-types',
    title: 'Commodity Types'
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/vehicle-types',
    title: 'Vehicle Types'
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/container-types',
    title: 'Container Types'
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/container-type-options',
    title: 'Container Type Options'
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/container-size-models',
    title: 'Container Size/Models'
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/service-types',
    title: 'Service Types'
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/distribution-types',
    title: 'Distribution Types'
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/rate-detail-descriptions',
    title: 'Rate Detail Descriptions'
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/jurisdictions',
    title: 'Jurisdictions'
},
{
    permission: 'MANAGE_MASTERS',
    to: '/subclient/system-settings/rate-types',
    title: 'Rate Types'
},
{
    permission: 'MANAGE_SCALE_TICKET_MESSAGE',
    to: '/subclient/system-settings/scale-ticket-message',
    title: 'Scale Ticket Message'
}]


export const transfer_station_sub_client_account_management = [
    {
        permission: "CUSTOMER_FILE_MAINTENANCE",
        to: "/subclient/account-management/accounts?sortBy=accountNumber&orderBy=ASC&page=1&pageSize=10",
        title: "Accounts",
    },
    {
        permission: "MANAGE_AR_TRANSACTIONS",
        to: "/subclient/account-management/transactions",
        title: "Transactions",
    },
]

export const transfer_station_weigh_master: MenuItem[] = [{
    permission: 'MANAGE_WEIGH_MASTER',
    to: '/subclient/weigh-master',
    title: 'Weighmaster'
}]

export const transfer_station_sub_client_billing = [
    {
        permission: 'BILLING_BATCH',
        to: '/subclient/billing/billing-batch',
        title: 'Billing Batch'
    },
    {
        permission: "MANAGE_STATEMENT_MESSAGE",
        to: "/subclient/billing/statement-message",
        title: "Statement Message",
    },
    {
        permission: "MANAGE_BILLING_GROUPS",
        to: "/subclient/billing/billing-groups",
        title: "Billing Groups",
    },
];

export const transfer_station_sub_client_rate_management = [
    {
        permission: 'MANAGE_JURISDICTION_DETAILS',
        to: '/subclient/rate-management/jurisdiction-details?sortBy=jurisdictionName&orderBy=ASC&page=1&pageSize=10',
        title: 'Jurisdiction Details'
    }
];

export const transfer_station_sub_client_reports: MenuItem[] = [
    {
        permission: ["REPORTS"],
        to: "/subclient/reports/system-reports",
        title: "System Reports",
    },
];
